import EmpIdCard from "../../components/EmpIdCard";

export default function EmployeeIdCards() {
    return <EmpIdCard />;
}

